<!-- @format -->

<template>
	<li
		class="el-dropdown-menu__item"
		:class="{
			'is-disabled': disabled,
			'el-dropdown-menu__item--divided': divided,
			['el-dropdown-menu__item--' + type]: type,
		}"
		:aria-disabled="disabled"
		:tabindex="disabled ? null : -1"
		@click="handleClick"
	>
		<i v-if="icon" :class="icon" />
		<slot />
	</li>
</template>
<script>
	export default {
		name: 'PcToolbarMenuItem',

		props: {
			disabled: Boolean,
			divided: Boolean,
			icon: String,
			type: String,
		},

		methods: {
			handleClick(event) {
				if (this.$el.disabled || this.disabled) return;
				this.$emit('click-event', event);
			},
		},
	};
</script>
